import { render, staticRenderFns } from "./edicionPTI.vue?vue&type=template&id=e48c3944&scoped=true"
import script from "./edicionPTI.vue?vue&type=script&lang=js"
export * from "./edicionPTI.vue?vue&type=script&lang=js"
import style0 from "./edicionPTI.vue?vue&type=style&index=0&id=e48c3944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48c3944",
  null
  
)

export default component.exports